export default __webpack_public_path__ + "static/media/account.fe01a19d.svg";